import {useAppSelector} from "@hooks/redux-hooks/hooks";
import {selectUser} from "@commons/core.slice";
import classNames from "classnames";
import React, {useMemo, useState} from "react";
import {LavoratorePresenzeRecord} from "@commons/mapping/LavoratorePresenzeRecord";

export enum PolicyTabEnum {
    MySelf = 'Per me',
    Team = 'Per il team',
    all = '*all'
}

export const useSelectorPolicy = (lavoratori: LavoratorePresenzeRecord[] | null) => {
    const user = useAppSelector(selectUser);
    const [selectedPolicy, setSelectedPolicy] = useState<PolicyTabEnum>(user?.userClass === 'EMPLOYEE' ? PolicyTabEnum.MySelf : PolicyTabEnum.all);
    const contratti = useMemo(() => {
        switch (selectedPolicy) {
            case PolicyTabEnum.MySelf:
                return lavoratori ? lavoratori.filter((lavoratore) => lavoratore.codiceFiscale === user?.codiceFiscale) : [];
            case PolicyTabEnum.Team:
                return lavoratori ? lavoratori.filter((lavoratore) => lavoratore.codiceFiscale !== user?.codiceFiscale) : [];
            default:
                return lavoratori || [];
        }
    }, [user, lavoratori, selectedPolicy])

    return {selectedPolicyTab: selectedPolicy, setSelectedPolicyTab: setSelectedPolicy, contratti};
}

interface Tabs4EmployeeProps {
    selectedPolicyTab: PolicyTabEnum,
    onchangePolicy: (oldPolicy: PolicyTabEnum, newPolicy: PolicyTabEnum) => void,
}

export const Tabs4Employee: React.FC<Tabs4EmployeeProps> = ({
                                                                selectedPolicyTab,
                                                                onchangePolicy
                                                            }) => {
    const {userClass} = useAppSelector(selectUser) || {userClass: undefined};
    return userClass === 'EMPLOYEE' ? <div className="inline-flex space-x-2">
        <button type={"button"} className={classNames("mt-2", selectedPolicyTab === PolicyTabEnum.MySelf ? "btnPrimary" : "btnDefault")}
                onClick={() => onchangePolicy(selectedPolicyTab, PolicyTabEnum.MySelf)}>
            Per me
        </button>
        <button type={"button"} className={classNames("mt-2", selectedPolicyTab === PolicyTabEnum.Team ? "btnPrimary" : "btnDefault")}
                onClick={() => onchangePolicy(selectedPolicyTab, PolicyTabEnum.Team)}>
            Per il team
        </button>
    </div> : null;
}

export default Tabs4Employee;